import { generateStrategies } from "../../../calculations/generateStrategies";
import { IGenerateStrategyProps, IStrategy, ViewType } from "../../../types";
import StrategyCard from "./strategy-card";
import MultiSelectDropdown from "../../dropdown/dropdown";
import { useState } from "react";

const GenerateStrategy = (props: IGenerateStrategyProps) => {
  const [sortingField, setSortingField] = useState("breakeven");
  const strategies = generateStrategies(props);

  const checkNumberWithinRange = (num: number, start: number, end: number) => {
    if (num) {
      return num >= start + 0.3 && num <= end - 0.3;
    }
    return false;
  };
  const checkBreakEven = (strategy: IStrategy) => {
    let result = false;
    if (strategy.callBreakEvenPercentage) {
      result = checkNumberWithinRange(
        strategy.callBreakEvenPercentage,
        props.from,
        props.to
      );
    }
    if (!result && strategy.putBreakEvenPercentage) {
      result = checkNumberWithinRange(
        strategy.putBreakEvenPercentage,
        props.from,
        props.to
      );
    }
    return result;
  };
  const filteredStrategies = strategies.filter((val) => {
    if (
      //Neutral and moderate strategies
      val.types &&
      val.types.includes(props.viewType) &&
      val.types.includes(ViewType.Neutral) &&
      val.maxProfitROI > 1
    ) {
      return val;
    } else if (
      //filter extremely bullish strategies
      val.types &&
      val.types.includes(props.viewType) &&
      val.types.includes(ViewType["Extremely Positive"]) &&
      checkBreakEven(val)
    ) {
      return val;
    } else if (
      //filter extremely bearish strategies
      val.types &&
      val.types.includes(props.viewType) &&
      val.types.includes(ViewType["Extremely Negative"]) &&
      checkBreakEven(val)
    ) {
      return val;
    }
    return val.riskRewardRatio >= 1 && checkBreakEven(val);
  });

  const sortStrategies = () => {
    if (sortingField === "riskRewardRatio" || sortingField === "maxProfit") {
      return filteredStrategies.sort(
        (a, b) => (b as any)[sortingField] - (a as any)[sortingField]
      );
    } else if (sortingField === "maxLoss") {
      return filteredStrategies.sort(
        (a, b) => (a as any)[sortingField] - (b as any)[sortingField]
      );
    } else {
      return filteredStrategies.sort((a, b) => {
        return (
          Math.abs(a.callBreakEvenPercentage || a.putBreakEvenPercentage || 0) -
          Math.abs(b.callBreakEvenPercentage || b.putBreakEvenPercentage || 0)
        );
      });
    }
  };

  const sortedStrategies = sortStrategies();

  const sortingData = [
    {
      field: "Highest R:R ratio",
      value: "riskRewardRatio",
    },
    {
      field: "Lowest Risk",
      value: "maxLoss",
    },
    {
      field: "Highest Profit",
      value: "maxProfit",
    },
    {
      field: "Highest Success %",
      value: "breakeven",
    },
  ];
  const handleSortingChanged = (value: any) => {
    setSortingField(value.value);
  };
  return (
    <div>
      {sortedStrategies.length > 0 ? (
        <div>
          <div className="e-field" style={{ textAlign: "center" }}>
            Sort By
            <MultiSelectDropdown
              inline={true}
              field="field"
              defaultValue={sortingData[3]}
              dataSource={sortingData}
              selectionChanged={handleSortingChanged}
            ></MultiSelectDropdown>
          </div>

          <h5
            className="text-success"
            style={{ marginLeft: "10px", textAlign: "center" }}
          >
            {sortedStrategies.length} smart strategies found
          </h5>
          {sortedStrategies.map((val, key) => {
            return <StrategyCard data={val} index={key} key={key} />;
          })}
        </div>
      ) : (
        <div style={{ fontWeight: "bold", textAlign: "center" }}>
          No strategy is satisying our smart filter criteria for the current
          view. Please increase or decrease the Target to filter more
          strategies.
        </div>
      )}
    </div>
  );
};

export default GenerateStrategy;
